import { Reveal } from "@/components/landing/Reveal";
import { steps } from "@/lib/landingData";

export const HowItWorks = () => {
  return (
    <section data-testid="how" id="how" className="relative py-28">
      <div className="mx-auto max-w-7xl px-6 lg:px-8">
        <Reveal className="mx-auto max-w-3xl text-center">
          <p className="text-xs font-semibold uppercase tracking-[0.3em] text-gradient">
            How It Works
          </p>
          <h2 className="mt-5 font-mega text-4xl leading-[0.95] text-white sm:text-5xl lg:text-6xl">
            Dream. Plan. Act. <span className="text-gradient">Become.</span>
          </h2>
        </Reveal>

        <div className="relative mt-20">
          <div className="absolute left-0 right-0 top-8 hidden h-px bg-gradient-to-r from-transparent via-white/20 to-transparent lg:block" />

          <div className="grid grid-cols-1 gap-12 sm:grid-cols-2 lg:grid-cols-4 lg:gap-8">
            {steps.map((s, i) => (
              <Reveal key={s.n} delay={i * 0.1} className="relative">
                <div className="relative z-10 mb-6 flex">
                  <div className="flex h-16 w-16 items-center justify-center rounded-full border border-white/12 bg-[#0C0C0E] font-mega text-xl text-gradient shadow-[0_0_40px_-10px_rgba(168,85,247,0.6)]">
                    {s.n}
                  </div>
                </div>
                <h3 className="font-display text-2xl font-bold uppercase tracking-tight text-white">
                  {s.title}
                </h3>
                <p className="mt-3 text-sm leading-relaxed text-muted-foreground">
                  {s.copy}
                </p>
              </Reveal>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default HowItWorks;
